import React from 'react';
import { I18n } from 'aws-amplify';
import { Authenticator } from 'aws-amplify-react';

import MySignIn from './lap-auth/lapSignin.js';
import ArchLikeSignIn from './lap-auth/archlikesignin.js';
import WindSignIn from './lap-auth/windsignin.js';
import FirstSignUp from './lap-auth/firstSignup.js';
import MyConfirmSignUp from './lap-auth/lapConfirmSignup.js';
import CheckPassView from './lap-auth/checkPassView.js';
import MyVerifyContact from './lap-auth/lapVerifyContact.js'; // emailaddress変更時に使う
import MyForgotPassword from './lap-auth/lapForgotPassword.js';
import SecondSignUp from './lap-auth/secondSignup.js';
import Confirmation from './lap-auth/confirmation.js';
import ReagreeTermDocs from './lap-auth/reagreeTermDocs.js';
import LapTheme from './lap-auth/lapTheme.js';
import dict from './util/dict.js';
import QueryStrUtil from './util/queryStrUtil.js';
import { GET_LANG_API } from '../configures/val.js';

import MyPageTop from './mypage/topview.js';
import axios from 'axios';

const myQueryStrUtil = new QueryStrUtil();

export class MainView extends React.Component {
  constructor(props) {
    super(props);
    I18n.putVocabularies(dict);
  }
  componentDidMount() {
    // request headerにあるaccept-languageをresponse bodyとして返してくれるlambdaです
    axios.get(GET_LANG_API).then((response) => {
      const headers = response.data.input.headers;
      let langs = 'ja,';
      if (headers.hasOwnProperty('Accept-Language')) {
        langs = headers['Accept-Language'];
      } else if (headers.hasOwnProperty('accept-language')) {
        langs = headers['accept-language'];
      }
      const langArr = langs.split(',');
      
      // accept-languageのうち最初の値をグローバルに使う
      window.LAPLACEID_LOCALE = 'en';
      // ja: chrome, firefox
      // ja-JP: ie11, edge
      // ja-jp: safari
      if ('ja' === langArr[0] ||'ja-JP' === langArr[0] || 'ja-jp' === langArr[0]) {
        window.LAPLACEID_LOCALE = 'ja';
      } else {
        window.LAPLACEID_LOCALE = 'en';
      }
      I18n.setLanguage(window.LAPLACEID_LOCALE);
      this.forceUpdate();
    }).catch((err) => {
      console.log('err');
      console.log(err);
    });
  }
  moveMypageSignin = () => {
     return (
      <Authenticator hideDefault={true} onStateChange={this.handleAuthStateChange} theme={LapTheme}>
        <MySignIn />
        <FirstSignUp />
        <SecondSignUp />
        <MyConfirmSignUp />
        <CheckPassView />
        <MyForgotPassword />
        <MyVerifyContact />
        <ReagreeTermDocs />
        <Confirmation />
        <MyPageTop />
      </Authenticator>
    ); 
  }
  render () {
    let app = myQueryStrUtil.getParamContent('app');
    if (app.includes('grandarch')) {
      return(this.moveMypageSignin());
    }
    let url = myQueryStrUtil.getParamContent('callback');
    if (url.includes('wind')) {
      return (
        <WindSignIn />
      ); 
    } else if (url.includes('megasolar') || url.includes('login')){
      return (
        <ArchLikeSignIn />
      );
    } else {
      return(this.moveMypageSignin());
    }
  }
}
